import { useState } from "react";

export default function EmailListDisplay({ emailList, nameList, setShowPreviousEmails, setShowPreviousNames, monthInQuestion, componentName = null }) {
  const [copied, setCopied] = useState("");

  const copyToClipboard = async () => {
    const listToCopy = nameList || emailList;
    const textToCopy = listToCopy.join('\n');
    
    try {
      await navigator.clipboard.writeText(textToCopy);
      setCopied(`Successfully copied ${listToCopy.length} ${nameList ? 'names' : 'emails'}!`);
    } catch (error) {
      setCopied("Failed to copy to clipboard");
    }

    setTimeout(() => {
      setCopied("");
    }, 3000);
  };
  // parse month from monthInQuestion to be more user readable yyyy-mm -> MMMM yy
  const formatMonth = (monthString) => {
    const [year, month] = monthString.split('-');
    return new Date(year, month - 1).toLocaleString('default', { month: 'long', year: 'numeric' });
  };

  const handleClose = () => {
    if (componentName === "Emails-Prev") setShowPreviousEmails(false);
    if (componentName === "Names-Prev") setShowPreviousNames(false);
  };

  const displayList = nameList || emailList;
  const listType = nameList ? 'Names' : 'Emails';

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-xl shadow-2xl w-[90%] max-w-2xl max-h-[80%] flex flex-col">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-gray-200">
          <div>
            <h3 className="text-xl font-bold text-ktx-purple">
              {listType} List
            </h3>
            <p className="text-gray-600 text-sm mt-1">
              {displayList?.length || 0} {listType.toLowerCase()} for {formatMonth(monthInQuestion)}
            </p>
          </div>
          
          <button
            onClick={handleClose}
            className="p-2 hover:bg-gray-100 rounded-full transition-colors"
          >
            <svg className="w-6 h-6 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* Content */}
        <div className="flex-1 overflow-hidden flex flex-col">
          {/* Copy Button */}
          <div className="p-4 border-b border-gray-100">
            <button 
              onClick={copyToClipboard}
              className="w-full bg-ktx-purple text-white py-3 px-4 rounded-lg hover:bg-ktx-navy transition-colors font-medium flex items-center justify-center gap-2"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
              </svg>
              Copy {listType}
            </button>
          </div>

          {/* List Display */}
          <div className="flex-1 overflow-y-auto p-4">
            {displayList && displayList.length > 0 ? (
              <div className="space-y-2">
                {displayList.map((item, index) => (
                  <div 
                    key={index}
                    className="p-3 bg-gray-50 rounded-lg border border-gray-200 hover:bg-gray-100 transition-colors"
                  >
                    <div className="flex items-center gap-3">
                      <span className="text-sm text-gray-500 font-mono w-8">
                        {index + 1}.
                      </span>
                      <span className="text-gray-800 font-medium flex-1">
                        {item}
                      </span>
                      {!nameList && (
                        <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 12a4 4 0 10-8 0 4 4 0 008 0zm0 0v1.5a2.5 2.5 0 005 0V12a9 9 0 10-9 9m4.5-1.206a8.959 8.959 0 01-4.5 1.207" />
                        </svg>
                      )}
                      {nameList && (
                        <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                        </svg>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="flex items-center justify-center h-full text-center">
                <div>
                  <div className="text-gray-400 text-6xl mb-4">
                    {nameList ? '👥' : '📧'}
                  </div>
                  <p className="text-gray-500 text-lg">No {listType.toLowerCase()} found</p>
                  <p className="text-gray-400 text-sm">This list is currently empty</p>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Success Message */}
        {copied && (
          <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2">
            <div className="bg-green-500 text-white px-4 py-2 rounded-lg shadow-lg flex items-center gap-2">
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
              {copied}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}